import ColorPalette from '../../../../components/styling/ColorPalette';

const styles = theme => ({
  root: {
    flex: 1,
    flexGrow: 1,
    display: 'block',
    textTransform: 'capitalize',
    fontSize: '16px',
    color: ColorPalette.primaryText,
    width: 'calc(100% - 5px)',
    maxWidth: '100%',
    height: 90,
  },
  wrapper: { height: 90 },
  textColorPrimary: {
    borderRadius: 0,
    height: 90,
  },
  textColorPrimarySelected: {
    padding: '5px 2.5px',
    backgroundColor: '#ffffff',
    color: ColorPalette.primary,
    height: 'calc(100% - 5px)',
    minHeight: 'calc(100% - 5px)',
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/calendar/CalendarTabStyles.js